module.exports = __webpack_public_path__ + "static/media/18.f7f2d32e.jpg";